export default __webpack_public_path__ + "static/media/tavi_cube@2x.3b9cabf7.jpg";